import React from 'react';

import { LoginModel, loginModelInitial } from '../../Models/LoginModel';

export interface IAuthContextProps {
    login: LoginModel,
    signin: (login: LoginModel, callback: () => void) => void,
    signout: (callback: () => void) => void
}

export const authContextInitial: IAuthContextProps = {
    login: loginModelInitial,
    signin: (login: LoginModel, callback: () => void) => { callback(); }, 
    signout: (callback: () => void) => { callback(); }
};

export const AuthContext = React.createContext(authContextInitial);



